module.exports = __webpack_public_path__ + "img/07-2.fd84c5ba.png";